<template>
  <div class="pa-3">
    <v-form @submit.prevent="next">
      <v-alert
        v-if="ShowErrorMessage && !mandatoryFieldCompiled"
        color="red darken-4"
        dark
        icon="mdi-alert-octagon-outline"
        dense
      >
        Inserisci una descrizione per questo evento.
      </v-alert>
      <v-text-field
        ref="input"
        v-model="eventInfo.descrizione"
        class="mb-9"
        outlined
        label="Descrizione Intervento"
        name="headquarter"
        type="text"
      />
    </v-form>

    <v-form @submit.prevent="next">
      <!-- <v-text-field
        ref="input"
        v-model="eventInfo.commessa.codiceCommessa"
        class="mb-9"
        outlined
        label="Commessa"
        name="commessa"
        type="text"
      /> -->

      <v-combobox
        v-model="codiceCommessa"
        label="Commessa"
        name="commessa"
        variant="outlined"
        outlined
        ref="txtCommessa"
        type="text"
        :hide-no-data="true"
        @change="codiceCommessa_Select"
        @keyup="codiceCommessa_keyup"
        class="mb-9"
        clearable
        :items="commesseItems"
      >
      </v-combobox>
    </v-form>

    <v-textarea
      clearable
      clear-icon="mdi-close-circle"
      label="Note"
      auto-grow
      rows="1"
      row-height="15"
      outlined
      v-model="eventInfo.note"
    ></v-textarea>

    <v-checkbox v-model="lampeggia" label="Metti in evidenza"></v-checkbox>
  </div>
</template>

<script>
import EasyPlanClient from "../../../utils/EasyPlanClient";
export default {
  props: ["eventInfo","updateComponents"],
  // watch: {},
  watch: {
    eventInfo: function (oldVal, newVal) {
      console.log("prop changed");
      this.$refs.txtCommessa.lazySearch=null; 
      this.codiceCommessa=null;
      this.ShowErrorMessage = false;
    },
  },

  data: () => ({
    error: null,
    codiceCommessa:"",
    name: "",
    ShowErrorMessage: false,
    Info: null,
    disabled: false,
    dialog: false,
    selectedClient: "",
    selectedSede: "",
    row: 0,
    sede: [],
    srcCodiceCommessa: "",
    clients: [],
    commesse: [],
    commesseItems: [],
    clientInfo: {
      descrizione: "",
      indirizzo: "",
      cap: "",
      citta: "",
      provincia: "",
      telefono: "",
      mail: "",
    },
  }), 
  computed: {
    mandatoryFieldCompiled: {
      get() {
        return Boolean(!this.isEmptyOrSpaces(this.eventInfo.descrizione));
      },
    },
    lampeggia: {
      get() {
        return Boolean(
          this.eventInfo.lampeggia == "true" || this.eventInfo.lampeggia == true
        );
      },
      set(value) {
        this.eventInfo.lampeggia = value;
      },
    },
  },
  mounted() {
    console.log(this.eventInfo);
    // eventInfo:this.eventInfo,
  },

  created() {
    this.initialize();

    this.searchCommesse("");
  },

  methods: {
    codiceCommessa_keyup() {
      this.codiceCommessa_Select(this.$refs.txtCommessa.lazySearch);
    },
    codiceCommessa_Select(select, a) {
      if (select != null && select != '') {
        let commesse = this.commesse.filter((c) => c.codiceCommessa == select);
        console.info("select select", select);
        console.info("select this.commesse", this.commesse);
        console.info("select commesse", commesse);
        if (commesse.length > 0) {
          let commessa = commesse[0];
          console.info("commessa", commessa);
          this.eventInfo.descrizione = commessa.descrizione;
          
          this.eventInfo.idCliente = commessa.codiceCliente;
          
          console.info(" this.eventInfo.indirizzoCompleto",  this.eventInfo.indirizzoCompleto);
          this.eventInfo.indirizzoCantiere = commessa.indirizzoCantiere;
          this.eventInfo.cittaCantiere = commessa.cittaCantiere;
          this.eventInfo.capCantiere = commessa.capCantiere;
          this.eventInfo.provinciaCantiere = commessa.provinciaCantiere;
          this.eventInfo.indirizzoCompleto=commessa.indirizzoCompleto;
          console.info(" this.eventInfo.indirizzoCompleto",  this.eventInfo.indirizzoCompleto);
          this.eventInfo.commessa = commessa;
          this.eventInfo.idCommessa=commessa.idCommessa;
          let evInfo=this.eventInfo;
          this.eventInfo=null; 
          this.$forceUpdate();
          this.eventInfo=evInfo;
          this.$emit("commessaSelected",commessa);
          console.info("this.eventInfo", this.eventInfo);
        } else {
        console.info("select commesse non esistente", commesse);
          this.eventInfo.commmessa.codiceCommessa = select;
        }
      }
      else{
        
      this.$refs.txtCommessa.lazySearch=null; 
      this.codiceCommessa=null;
          //      this.eventInfo.commessa = null;
          // this.eventInfo.idCommessa=0;
          // let evInfo=this.eventInfo;
          // this.eventInfo=null; 
          // this.$forceUpdate();
          // this.eventInfo=evInfo;
      }
      console.info("select", select);
      console.info("a", a);
    },
    searchCommesse(src) {
      console.log("loading commesse...");
      this.loading = true;
       this.commesseItems=[];
       this.commesse=[];
      EasyPlanClient.Order.Search(this.$route.params.companyAlias, src,true)
        .then((res) => {
          this.commesse = res.data.data;
          
          for (let i = 0; i < res.data.data.length; i++) {
            this.commesseItems.push(res.data.data[i].codiceCommessa);
          }
          console.debug("commesse", this.commesse);
          console.debug("this.commesseItems", this.commesseItems);
        })
        .catch((error) => {
          console.log(error);
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    show: function () {
      alert();
    },
    CanGoFarward() {
      this.ShowErrorMessage = true;
      return this.mandatoryFieldCompiled; // > 0;
    },
    isEmptyOrSpaces: function (str) {
      return str === null || str.match(/^ *$/) !== null;
    },
    initialize() {
      if (
        localStorage.userToken == undefined ||
        localStorage.userToken == "null"
      ) {
        console.debug("logging off");
        localStorage.userToken = null;

        this.$router.push({
          name: "login",
          params: { companyAlias: this.$route.params.companyAlias },
        });
      }
    },
  },
};
</script>

<style>
.addCliente {
  margin-top: 12px;
}

.addIntervento {
  margin-top: 12px;
}
</style>